import React from 'react';

function Footer(){
    return (
        <footer>
          <p>광고 및 후원문의 : contact@soogun.org</p>
          <p className="coupang-notice">이 포스팅은 쿠팡 파트너스 활동의 일환으로, 이에 따른 일정액의 수수료를 제공받습니다.</p>
          <p>&copy; 2024 contact@soogun.org. All rights reserved.</p>
        </footer>
      );
 }

export default Footer;
